import ShopPromoLargeCard from "./large/shoppromo_large_card";
import ShopPromoSmallCard from "./small/shoppromo_small_card";
import PromoShopPromo from "./large/legacy/promo_shoppromo";
import PromoBrandShopPromo from "./brand/promo_brandshoppromo";
import Cinema from "./small/legacy/cinema";
import Carousel from "./legacy_carousel/carousel";

export function initPromoBrandShopPromo() {
    let containers = document.getElementsByClassName('promo_brandshoppromo_mo--container');

    if(containers.length === 0) {
        containers = document.getElementsByClassName('promo_brandshoppromo--container');
    }

    [].forEach.call(containers, container => {
        if (container.getAttribute("data-tracked") !== "true") {
            container.setAttribute("data-tracked", "true");
            new PromoBrandShopPromo(container);
        }
    });
}

export function initCarouselsForLargeShopPromos(featureIndex) {
    const largeCardContainers = document.getElementsByClassName('promo_shoppromo-large-card--container');
    if (largeCardContainers.length === 0) {
        initCarouselForLargeShopPromosLegacy()
    } else {
        initCarouselForLargeShopPromosCard(featureIndex)
    }

}

function initCarouselForLargeShopPromosCard(featureIndex){
    const shoppromoLargeCardContainer = document.querySelector(`[data-feature-index="${featureIndex}"].promo_shoppromo-large-card--container`)
    new ShopPromoLargeCard(shoppromoLargeCardContainer);
}

function initCarouselForLargeShopPromosLegacy(){
    if (window.o_promo_shoppromo === null || window.o_promo_shoppromo === undefined) {
        window.o_promo_shoppromo = new PromoShopPromo();
    }
    const largeContainers = document.getElementsByClassName('promo_shoppromo-large--container');
    const promoShopPromo = window.o_promo_shoppromo;

    //Make non-cinema or single entry cinema variant visible - for carousel with multiple slides this is done in carousel.js
    [].forEach.call(largeContainers, largeContainerDom => {
        if (largeContainerDom.getAttribute("data-isslidingcinemaenabled") === "false") {
            largeContainerDom.classList.add('promo_shoppromo-large--visible');
            PromoShopPromo.loadImages(largeContainerDom);
        }

        if (largeContainerDom.getAttribute("data-tracked") !== "true") {
            largeContainerDom.setAttribute("data-tracked", "true");
            promoShopPromo.trackInitialViewLargeShopPromo(largeContainerDom);
        }

        let itemContainer = largeContainerDom.querySelector('.promo_shoppromo-large--item-container');
        if (itemContainer != null) {
            if (largeContainerDom.getAttribute("data-initialized") !== "true") {
                largeContainerDom.setAttribute("data-initialized", "true");

                const isCarousel = itemContainer.classList.contains("promo_shoppromo-large--item-scroll-container");
                if (isCarousel) {
                    if (!window.o_promo_carousels) {
                        window.o_promo_carousels = [];
                    }
                    window.o_promo_carousels.push(new Carousel(largeContainerDom));
                }
            }
        }
    });
}

export function initCinemasForSmallShopPromos(featureIndex){
    const cinemaCardDomList = document.getElementsByClassName("promo_shoppromo-small-card--container");

    if (cinemaCardDomList.length === 0){
        initCinemasForSmallShopPromosLegacy()
    }else{
        initCinemasForSmallShopPromosCard(featureIndex)
    }

}

function initCinemasForSmallShopPromosCard(featureIndex){
    const shoppromoSmallCardContainer = document.querySelector(`[data-feature-index="${featureIndex}"].promo_shoppromo-small-card--container`)
    new ShopPromoSmallCard(shoppromoSmallCardContainer);
}

function initCinemasForSmallShopPromosLegacy() {
    const config = {
        containerSelector: '.promo_shoppromo-small--tile-container',
        tileSelector: '.promo_shoppromo-small--tile',
        buttonLeftSelector: '.promo_shoppromo-small--cinema-button-left',
        buttonRightSelector: '.promo_shoppromo-small--cinema-button-right',
        buttonHideClass: 'promo_shoppromo-small--cinema-button-hide',
        tilePaddingRight: 8
    };

    const cinemaDomList = document.querySelectorAll(".promo_shoppromo-small--cinema-container");
    [].forEach.call(cinemaDomList, cinemaDom => {
        if (cinemaDom.getAttribute("data-initialized") !== "true") {
            cinemaDom.setAttribute("data-initialized", "true");
            new Cinema(cinemaDom, config);
        }
    });
}